import { getRem } from 'lib/core';
import { IconArrowDropDown } from 'lib/icons';
import styled, { css } from 'styled-components';

const ICON_SIZE = getRem(16);

const ChipCaret = styled(IconArrowDropDown)`
  fill: ${({ theme }) => theme.color.text.light.secondary.value};
  flex-shrink: 0;
  height: ${ICON_SIZE};
  margin-left: ${getRem('2px')};
  width: ${ICON_SIZE};
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: rotate(180deg);
    `};
`;

export { ChipCaret };
